export default __webpack_public_path__ + "static/media/hero.67d6bb6d.svg";